import { AlfredTableColumn } from 'components/organisms/AlfredTable';
import { ProjectModel, ProjectType } from 'core/domain/project/model/projectModel';
import { projectTypeTranslationManager } from 'utils/projects';
import './styles.scss';

interface Props {
  translations: Record<string, string>;
}

export const ProjectsListColumns = ({
  translations,
}: Props): AlfredTableColumn<ProjectModel>[] => {
  const {
    nameTitle,
    typeTitle,
    supportEmailTitle,
    notReportedText,
  } = translations;

  return [
    {
      title: nameTitle,
      key: 'name',
      width: '40%',
      render: (text, { logo, name }) => (
        <span>
          <img className={'ProjectsPage__columns'} src={logo} alt={name} />
          {name}
        </span>
      ),
    },
    {
      title: typeTitle,
      key: 'type',
      width: '20%',
      render: (text, { type }) => projectTypeTranslationManager[type as ProjectType],
    },
    {
      title: supportEmailTitle,
      key: 'supportEmail',
      width: '40%',
      dataIndex: 'support_email',
      render: (support_email) => {
        return !!support_email.length
          ? <span>{support_email}</span>
          : <span className={'Column__notReportedText'}>{notReportedText}</span>
      },
    },
  ];
};
